/* JM ADDICT — animações ao fazer scroll (página inicial) */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var path = window.location.pathname.replace(/\/$/, '');
  var isHome = path === '' || path === root.replace(/\/$/, '');
  if (!isHome) return;
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var sections = document.querySelectorAll('main .shopify-section, #MainContent .shopify-section');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-in');
          io.unobserve(en.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -6% 0px' });

    Array.prototype.forEach.call(sections, function (sec, i) {
      if (i === 0) return;                                  // hero fica logo visível
      if (sec.querySelector('.jm-mobile-nav, header')) return; // nunca tocar em elementos fixos
      var r = sec.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.9) return;         // já está no ecrã
      sec.classList.add('jm-reveal');
      io.observe(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
